/**
 * Created by Shree on 7/30/2018.
 */
export class AssessmentModel {
  constructor(
    public assessment_id ?: string,
    public name ?: string,
    public description?: string,
    public skills : Array<any> = [],
    public note?: string,
    public type?: string,
    public scoring: Array<any> = [],
    public total_score?: number,
    public passing_score?: number,
    public question_id : Array<any> = [],
    public certificate_id?: string,
    public lang ?: string,
    public instruction ?: string,
    public feedback ?: string,
    public fail_feedback ?: string,
    public duration ?: number,
    public is_deleted?: boolean,
    public created_by?: string,
    public updated_by?: string,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/models/assessment.model.ts